export enum CountryCodes {
  NZ = "New Zealand",
  AU = "Australia"
}
